<!-- eslint-disable max-len -->
<template>
  <div id="wrapper" class="wrapper">
    <LoadingSpinner v-if="pageLoading"/>
    <div v-if="!pageLoading" class="search offer_main_block">
      <div class="body_inner">
        <div
            v-if="scrollState || offers.length === 0"
            class="
            w-full
            bg-white
            scrollssearch_block
            justify-start
            fixed
            left-0
            w-full
            pt-3
            pb-3
          "
        >
          <div class="body_inner">
            <div class="search_form_block flex items-center">
              <SearchCard></SearchCard>
              <div class="flex justify-between mt-0 filter_action_block">
                <button
                    class="
                    flex
                    items-center
                    justify-center
                    btn_apply
                    rounded-lg
                    text-white
                    btn_action
                  "
                    @click="showFilters = !showFilters"
                >
                  <FilterSVG
                      class="search__btn-filter-icon"
                      style="fill: #ffffff"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
            v-if="offers.length > 0 && !scrollState"
            class="
            block
            relative
            bggreen
            rounded-md
            pl-4
            pr-4
            pt-5
            pb-5
            item-block
            mt-2
            mb-5
            bessere-min-height
          "
        >
          <div class="flex items-center">
            <div class="block w-3/4">
              <h4 class="block text-smm font-bold text-white mb-2">
                {{ $t("pages.offers.banners.auth[0].heading") }}
              </h4>
              <p class="block text-xss font-normal text-white mb-2">
                {{ $t("pages.offers.banners.auth[0].subHeading") }}
              </p>
              <p class="block text-xss font-bold underline text-white">
                {{ $t("pages.offers.banners.auth[0].link") }}
              </p>
            </div>
            <div class="block w-1/4">
              <div class="block absolute right-0 top-4 img_box -right-2.5">
                <svg
                    class="w-24 h-24"
                    viewBox="0 0 75 96"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                      d="M48 0.5C21.8085 0.5 0.5 21.8085 0.5 48C0.5 74.1915 21.8085 95.5 48 95.5C74.1915 95.5 95.5 74.1915 95.5 48C95.5 21.8085 74.1915 0.5 48 0.5ZM48 21.875C54.5574 21.875 59.875 27.1926 59.875 33.75C59.875 40.3074 54.5574 45.625 48 45.625C41.4426 45.625 36.125 40.3074 36.125 33.75C36.125 27.1926 41.4426 21.875 48 21.875ZM69.375 61.1528C69.375 67.9429 60.7134 74.125 48 74.125C35.2866 74.125 26.625 67.9429 26.625 61.1528V59.5472C26.625 57.1057 28.6057 55.125 31.0472 55.125H64.9528C67.3942 55.125 69.375 57.1057 69.375 59.5472V61.1528Z"
                      fill="white"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>

        <!-- --------------offer_main_block ---------------->
        <div
            v-if="offers.length === 0 && furtherOffers.length === 0"
            class="
            absolute
            inset-0
            flex
            items-center
            justify-center
            pl-10
            pr-10
            offer_main_block
          "
        >
          <div class="offerno_result">
            <div class="flex items-center justify-center iconbox">

            </div>
            <h5>{{ $t("pages.offers.no_result.heading") }}</h5>
            <p class="font-normal">
              {{ $t("pages.offers.no_result.description") }}
            </p>
            <p>
              <a class="reset_fill" @click="resetFilter">
                {{ $t("pages.common.buttons.dis150") }}
              </a>
            </p>
          </div>
        </div>


        <!-- --------------offer_main_block ---------------->

        <div v-if="offers.length > 0" class="search_form_block">
          <h4 class="block relative font-bold text-md text-lgg mb-4">
            {{ $t("pages.offers.heading") }}:
          </h4>
          <SearchCard class="w-full" @date="onDate"></SearchCard>
          <div
              class="flex justify-between mt-0 filter_action_block w-full mt-4"
          >
            <button
                class="
                flex
                items-center
                justify-center
                btn_apply
                rounded-lg
                text-white
                btn_action btn-transparent
                w-full
              "
                @click="
                showFilters = !showFilters;
                fetchOffers;
                fetchFurtherOffers;
              "
            >
              <FilterSVG class="search__btn-filter-icon"/>
              <span>{{ $t("pages.offers.buttons.filter") }}</span>
            </button>
          </div>
        </div>

        <div v-if="offers.length > 0" class="newfilter-blcok mt-7">
          <div class="newfil-title flex items-center mb-4">
            <h2 class="block relative w-11/12 text-xs">
              <h4 class="block relative font-bold text-md text-lgg">
                {{ $t("pages.offers.results.title") }}:
              </h4>
            </h2>
            <p class="text-right w-01/12">

            </p>
          </div>

          <div class="newfillist-block">
            <div
                v-for="(offer, key) in offers"
                :key="`${offer.offer_id} + ${key}`"
                class="
                block
                relative
                walter-block
                bg-white
                rounded-lg
                walter-shadow
                mb-4
              "
            >
              <div class="flex align-start justify-start top-block mb-0.5 p-4">
                <div class="left-block w-3/5 relative">
                  <div class="flex items-center">
                    <div class="flex items-center">
                      <h4
                          class="
                          flex
                          align-center
                          justify-start
                          relative
                          text-sm
                          font-bold
                          text-darkblack
                          flex
                          lock-text
                        "
                      ></h4>
                      {{ $t("pages.common.buttons.dis73") }}:
                      <span
                          v-if="loggedIn"
                          @click="
                          () => {
                            if (loggedIn) {
                              $router.push({
                                name: 'offerDetails',
                                params: { id: offer.offer_id },
                              });
                            } else {
                              $router.push({ name: 'confirmCell' });
                            }
                          }
                        "
                          class="ml-1"
                      >
                        {{ offer.customer.id }} <span v-if="offer.isAltKunde">({{
                          $t("pages.offers.results.oldCustomer")
                        }})</span>
                      </span>
                      <span v-if="!loggedIn" class="text-danger ml-1">
                        locked
                      </span>
                      <svg
                          v-if="!loggedIn"
                          width="10"
                          height="11"
                          class="ml-1.5"
                          viewBox="0 0 10 11"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                            d="M8.5 5.5H1.5C0.947715 5.5 0.5 5.94772 0.5 6.5V10C0.5 10.5523 0.947715 11 1.5 11H8.5C9.05229 11 9.5 10.5523 9.5 10V6.5C9.5 5.94772 9.05229 5.5 8.5 5.5Z"
                            fill="#EE5B64"
                        />
                        <path
                            d="M2.5 5.5V3.5C2.5 2.83696 2.76339 2.20107 3.23223 1.73223C3.70107 1.26339 4.33696 1 5 1C5.66304 1 6.29893 1.26339 6.76777 1.73223C7.23661 2.20107 7.5 2.83696 7.5 3.5V5.5"
                            stroke="#EE5B64"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                      </svg>
                    </div>

                    <div class="wrapper">
                      <svg
                          width="14"
                          height="14"
                          class="ml-1.5 show"
                          viewBox="0 0 14 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          v-if="offer.is_verified == true ? true : false"
                          @click="showVerifiedModal"
                      >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M5.26853 1.66248C5.38845 1.64971 5.51634 1.68009 5.63246 1.76143L6.2158 2.17029C6.73895 2.5362 7.44038 2.53665 7.96319 2.17029L8.54588 1.76143C8.85553 1.54451 9.25155 1.68848 9.34926 2.05375L9.53285 2.7419C9.69778 3.3585 10.2348 3.80883 10.8707 3.8643L11.5797 3.92615C11.9563 3.95901 12.1673 4.32404 12.0075 4.66638L11.706 5.31156C11.4361 5.88997 11.5577 6.58039 12.0094 7.03162L12.5127 7.53487C12.7799 7.80194 12.7069 8.21698 12.3642 8.37667L11.7191 8.67745C11.1403 8.94679 10.7903 9.5535 10.846 10.1892L10.9085 10.8988C10.9415 11.2754 10.6184 11.5463 10.2536 11.4483L9.56606 11.2634C8.94953 11.098 8.29071 11.3375 7.92478 11.8604L7.51658 12.4437C7.29985 12.7535 6.87849 12.7542 6.66176 12.4444L6.25356 11.8604C5.88763 11.3375 5.22945 11.098 4.61293 11.2634L3.92478 11.4483C3.55996 11.5463 3.23744 11.2754 3.27048 10.8988L3.33298 10.1898C3.38895 9.55391 3.03826 8.94623 2.45929 8.6768L1.8141 8.37667C1.47134 8.21692 1.39814 7.8024 1.66567 7.53487L2.16957 7.03162C2.62129 6.58039 2.74285 5.88997 2.47296 5.31156L2.17153 4.66638C2.01172 4.32404 2.22202 3.95901 2.59861 3.92615L3.30824 3.8643C3.94416 3.80883 4.48056 3.3585 4.64548 2.7419L4.82973 2.05375C4.87859 1.87112 5.00214 1.74371 5.15199 1.68917C5.18946 1.67553 5.22856 1.66673 5.26853 1.66248ZM9.14614 5.1462C9.23675 5.05311 9.36003 4.99894 9.48989 4.99516C9.59053 4.99226 9.68971 5.01981 9.77444 5.07421C9.85917 5.12861 9.92551 5.20732 9.96476 5.30005C10.004 5.39277 10.0144 5.49518 9.99446 5.59389C9.97455 5.69259 9.9253 5.78298 9.85317 5.85323L6.51983 9.18656C6.42606 9.2803 6.2989 9.33295 6.16632 9.33295C6.03373 9.33295 5.90657 9.2803 5.8128 9.18656L4.14614 7.5199C4.09815 7.47382 4.05984 7.41864 4.03345 7.35758C4.00706 7.29651 3.99311 7.2308 3.99244 7.16428C3.99176 7.09776 4.00436 7.03177 4.02951 6.97018C4.05465 6.9086 4.09183 6.85264 4.13887 6.8056C4.18591 6.75856 4.24186 6.72139 4.30345 6.69624C4.36504 6.6711 4.43103 6.65849 4.49755 6.65917C4.56407 6.65984 4.62978 6.67379 4.69085 6.70018C4.75191 6.72657 4.80709 6.76488 4.85317 6.81287L6.16632 8.12602L9.14614 5.1462Z"
                            fill="#4890D2"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M7.97231 0.942424C8.23866 0.755836 8.54077 0.670709 8.83884 0.672892C9.49461 0.677696 10.1299 1.10408 10.3148 1.79529L10.499 2.48344C10.5561 2.69684 10.7373 2.84901 10.9573 2.8682L11.667 2.93005C12.7037 3.02052 13.3533 4.14656 12.9131 5.08956L12.6123 5.73474C12.5188 5.935 12.5595 6.16783 12.7158 6.32393L13.2197 6.82719C13.9558 7.56279 13.7301 8.84327 12.7868 9.28292L12.1416 9.5837C11.9412 9.67694 11.8227 9.88184 11.8421 10.1019L11.9046 10.8116C11.9956 11.8483 10.9996 12.6838 9.99444 12.4138L9.30694 12.2295C9.09347 12.1723 8.87119 12.2528 8.74444 12.434L8.33624 13.0173C7.73964 13.8701 6.43935 13.8701 5.84275 13.0173L5.43455 12.434C5.3078 12.2528 5.08552 12.1723 4.87205 12.2295L4.18455 12.4138C3.17937 12.6838 2.18343 11.8483 2.27439 10.8116L2.33689 10.1019C2.35626 9.88184 2.23777 9.67694 2.03741 9.5837L1.39158 9.28292C0.448344 8.84333 0.222832 7.56299 0.958635 6.82719L1.46254 6.32393C1.61882 6.16783 1.66015 5.935 1.56671 5.73474L1.26528 5.08891C0.825081 4.14591 1.47527 3.02052 2.51202 2.93005L3.221 2.8682C3.44109 2.84901 3.62226 2.69684 3.67934 2.48344L3.86358 1.79529C4.0653 1.04124 4.80277 0.602953 5.51853 0.682658C5.75712 0.709227 5.9936 0.793154 6.20668 0.942424L6.78936 1.35128C6.97154 1.4787 7.20779 1.47824 7.38897 1.35128L7.97231 0.942424ZM5.63246 1.76143C5.51634 1.68009 5.38845 1.64971 5.26853 1.66248C5.22856 1.66673 5.18946 1.67553 5.15199 1.68917C5.00214 1.74371 4.87859 1.87112 4.82973 2.05375L4.64548 2.7419C4.48056 3.3585 3.94416 3.80883 3.30824 3.8643L2.59861 3.92615C2.22202 3.95901 2.01172 4.32404 2.17153 4.66638L2.47296 5.31156C2.74285 5.88997 2.62129 6.58039 2.16957 7.03162L1.66567 7.53487C1.39814 7.8024 1.47134 8.21692 1.8141 8.37667L2.45929 8.6768C3.03826 8.94623 3.38895 9.55391 3.33298 10.1898L3.27048 10.8988C3.23744 11.2754 3.55996 11.5463 3.92478 11.4483L4.61293 11.2634C5.22945 11.098 5.88763 11.3375 6.25356 11.8604L6.66176 12.4444C6.87849 12.7542 7.29985 12.7535 7.51658 12.4437L7.92478 11.8604C8.29071 11.3375 8.94953 11.098 9.56606 11.2634L10.2536 11.4483C10.6184 11.5463 10.9415 11.2754 10.9085 10.8988L10.846 10.1892C10.7903 9.5535 11.1403 8.94679 11.7191 8.67745L12.3642 8.37667C12.7069 8.21698 12.7799 7.80194 12.5127 7.53487L12.0094 7.03162C11.5577 6.58039 11.4361 5.88997 11.706 5.31156L12.0075 4.66638C12.1673 4.32404 11.9563 3.95901 11.5797 3.92615L10.8707 3.8643C10.2348 3.80883 9.69778 3.3585 9.53285 2.7419L9.34926 2.05375C9.25155 1.68848 8.85553 1.54451 8.54588 1.76143L7.96319 2.17029C7.44038 2.53665 6.73895 2.5362 6.2158 2.17029L5.63246 1.76143Z"
                            fill="#4890D2"
                        />
                      </svg>

                      <span v-if="showModal && offer.is_verified" class="tooltip">{{
                          $t("pages.common.buttons.dis125")
                        }}</span>
                    </div>
                  </div>

                  <p
                      class="
                      flex
                      items-center
                      justify-start
                      mt-0.5
                      mb-0
                      text-xs
                      font-medium
                      text-darkgray1
                    "
                      @click="
                      () => {
                        if (loggedIn) {
                          $router.push({
                            name: 'offerDetails',
                            params: { id: offer.offer_id },
                          });
                        } else {
                          $router.push({ name: 'confirmCell' });
                        }
                      }
                    "
                  >
                    <span class="mr-1.5">
                      <svg
                          class="w-3.5 h-3.5"
                          viewBox="0 0 10 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                            d="M4.99984 0.666992C2.2667 0.666992 0.0415039 2.89219 0.0415039 5.62533C0.0415039 6.85231 0.491635 7.97757 1.23096 8.84277L1.23324 8.84505L1.23494 8.84733C1.23494 8.84733 3.34426 11.2542 4.09522 11.9708C4.59809 12.4502 5.40102 12.4502 5.90389 11.9708C6.75987 11.1544 8.7653 8.84619 8.7653 8.84619L8.76644 8.84448L8.76815 8.84277C9.50813 7.97756 9.95817 6.85231 9.95817 5.62533C9.95817 2.89219 7.73297 0.666992 4.99984 0.666992ZM4.99984 1.54199C7.26004 1.54199 9.08317 3.36513 9.08317 5.62533C9.08317 6.63893 8.71379 7.55983 8.10278 8.27425C8.09881 8.2788 6.04693 10.6255 5.30005 11.3379C5.12684 11.503 4.87227 11.503 4.69906 11.3379C4.07484 10.7423 1.90266 8.28143 1.89632 8.27425L1.89575 8.27368C1.28556 7.55932 0.916504 6.63865 0.916504 5.62533C0.916504 3.36513 2.73964 1.54199 4.99984 1.54199ZM4.99984 3.87533C4.45296 3.87533 3.98741 4.09616 3.68848 4.43245C3.38955 4.76875 3.24984 5.19998 3.24984 5.62533C3.24984 6.05067 3.38955 6.4819 3.68848 6.8182C3.98741 7.15449 4.45296 7.37533 4.99984 7.37533C5.54671 7.37533 6.01227 7.15449 6.3112 6.8182C6.61013 6.4819 6.74984 6.05067 6.74984 5.62533C6.74984 5.19998 6.61013 4.76875 6.3112 4.43245C6.01227 4.09616 5.54671 3.87533 4.99984 3.87533ZM4.99984 4.75033C5.32796 4.75033 5.51866 4.85762 5.65723 5.01351C5.7958 5.1694 5.87484 5.39442 5.87484 5.62533C5.87484 5.85623 5.7958 6.08125 5.65723 6.23714C5.51866 6.39303 5.32796 6.50033 4.99984 6.50033C4.67171 6.50033 4.48102 6.39303 4.34245 6.23714C4.20388 6.08125 4.12484 5.85623 4.12484 5.62533C4.12484 5.39442 4.20388 5.1694 4.34245 5.01351C4.48102 4.85762 4.67171 4.75033 4.99984 4.75033Z"
                            fill="#676666"
                        />
                      </svg>
                    </span>
                    {{ offer.location }}
                  </p>
                </div>

                <div class="right-block w-2/4 relative">
                  <p
                      class="
                      wishlist-icon
                      relative
                      text-sm text-right
                      flex
                      items-center
                      justify-end
                      mt-0
                      font-bold
                    "
                  >
                    <button
                        v-if="offer.favorite"
                        @click.prevent="selectedOffers(offer.offer_id, offer)"
                        :offer="offer"
                    >
                      <svg
                          width="20"
                          height="18"
                          viewBox="0 0 20 18"
                          fill="none"
                          :active="true"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                            d="M5.5 0.5C2.47122 0.5 0 2.97122 0 6C0 8.04808 1.54382 9.97645 3.42578 11.9541C5.30774 13.9318 7.62419 15.9347 9.46973 17.7803C9.61038 17.9209 9.80112 17.9999 10 17.9999C10.1989 17.9999 10.3896 17.9209 10.5303 17.7803C12.3758 15.9347 14.6923 13.9318 16.5742 11.9541C18.4562 9.97645 20 8.04808 20 6C20 2.97122 17.5288 0.5 14.5 0.5C12.7618 0.5 11.2484 1.43324 10 3.01855C8.75159 1.43324 7.23822 0.5 5.5 0.5ZM5.5 2C6.96429 2 8.18315 2.7792 9.36621 4.65039C9.43386 4.75727 9.52744 4.84531 9.63826 4.90632C9.74907 4.96732 9.87351 4.99931 10 4.99931C10.1265 4.99931 10.2509 4.96732 10.3617 4.90632C10.4726 4.84531 10.5661 4.75727 10.6338 4.65039C11.8168 2.7792 13.0357 2 14.5 2C16.7182 2 18.5 3.78178 18.5 6C18.5 7.20192 17.2938 9.02355 15.4883 10.9209C13.8418 12.6511 11.7952 14.4587 10 16.209C8.20484 14.4587 6.15821 12.6511 4.51172 10.9209C2.70618 9.02355 1.5 7.20192 1.5 6C1.5 3.78178 3.28178 2 5.5 2Z"
                            fill="#63B15B"
                        />
                        <path
                            d="M5.5 2C6.96429 2 8.18315 2.7792 9.36621 4.65039C9.43386 4.75727 9.52744 4.84531 9.63826 4.90632C9.74907 4.96732 9.87351 4.99931 10 4.99931C10.1265 4.99931 10.2509 4.96732 10.3617 4.90632C10.4726 4.84531 10.5661 4.75727 10.6338 4.65039C11.8168 2.7792 13.0357 2 14.5 2C16.7182 2 18.5 3.78178 18.5 6C18.5 7.20192 17.2938 9.02355 15.4883 10.9209C13.8418 12.6511 11.7952 14.4587 10 16.209C8.20484 14.4587 6.15821 12.6511 4.51172 10.9209C2.70618 9.02355 1.5 7.20192 1.5 6C1.5 3.78178 3.28178 2 5.5 2Z"
                            fill="#63B15B"
                        />
                      </svg>
                    </button>

                    <button
                        v-else
                        @click.prevent="selectedOffers(offer.offer_id, offer)"
                        :class="offer.favorite === true ? true : false"
                        :offer="offer"
                    >
                      <svg
                          width="20"
                          height="18"
                          viewBox="0 0 20 18"
                          class=""
                          :active="false"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                            d="M5.5 0.5C2.47122 0.5 0 2.97122 0 6C0 8.04808 1.54382 9.97645 3.42578 11.9541C5.30774 13.9318 7.62419 15.9347 9.46973 17.7803C9.61038 17.9209 9.80112 17.9999 10 17.9999C10.1989 17.9999 10.3896 17.9209 10.5303 17.7803C12.3758 15.9347 14.6923 13.9318 16.5742 11.9541C18.4562 9.97645 20 8.04808 20 6C20 2.97122 17.5288 0.5 14.5 0.5C12.7618 0.5 11.2484 1.43324 10 3.01855C8.75159 1.43324 7.23822 0.5 5.5 0.5ZM5.5 2C6.96429 2 8.18315 2.7792 9.36621 4.65039C9.43386 4.75727 9.52744 4.84531 9.63826 4.90632C9.74907 4.96732 9.87351 4.99931 10 4.99931C10.1265 4.99931 10.2509 4.96732 10.3617 4.90632C10.4726 4.84531 10.5661 4.75727 10.6338 4.65039C11.8168 2.7792 13.0357 2 14.5 2C16.7182 2 18.5 3.78178 18.5 6C18.5 7.20192 17.2938 9.02355 15.4883 10.9209C13.8418 12.6511 11.7952 14.4587 10 16.209C8.20484 14.4587 6.15821 12.6511 4.51172 10.9209C2.70618 9.02355 1.5 7.20192 1.5 6C1.5 3.78178 3.28178 2 5.5 2Z"
                            fill="#63B15B"
                        />
                      </svg>
                    </button>
                  </p>
                </div>
              </div>
              <div
                  class="
                  flex
                  align-start
                  justify-start
                  top-block
                  mb-0.5
                  pl-4
                  pb-4
                  pr-4
                "
                  @click="
                  () => {
                    if (loggedIn) {
                      $router.push({
                        name: 'offerDetails',
                        params: { id: offer.offer_id },
                      });
                    } else {
                      $router.push({ name: 'confirmCell' });
                    }
                  }
                "
              >
                <div class="left-block w-3/5 relative">
                  <h4
                      class="block relative text-sm font-bold text-darkblack flex"
                  >
                    {{
                      formatDate(offer.arrival_date, "DD.MM.YYYY", "YYYY-MM-DD")
                    }}
                  </h4>
                </div>
                <div class="right-block w-2/4 relative">
                  <p
                      class="
                      flex
                      items-center
                      justify-end
                      text-right
                      mt-0.5
                      mb-0
                      text-smm
                      font-bold
                      text-darkgray1
                    "
                  >
                    <span class="mr-0.5">
                      <svg
                          width="14"
                          height="13"
                          viewBox="0 0 14 15"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                            d="M6.99967 0.833008C3.3237 0.833008 0.333008 3.8237 0.333008 7.49967C0.333008 11.1757 3.3237 14.1663 6.99967 14.1663C10.6757 14.1663 13.6663 11.1757 13.6663 7.49967C13.6663 3.8237 10.6757 0.833008 6.99967 0.833008ZM7.17285 3.83301C8.49619 3.83301 9.06259 4.39182 9.51725 4.84082C9.71392 5.03482 9.71581 5.35118 9.52181 5.54785C9.32814 5.74452 9.01078 5.74641 8.81478 5.55241C8.40778 5.15074 8.0865 4.83301 7.1735 4.83301C6.37117 4.83301 5.67028 5.37067 5.29395 6.16634H6.83301C7.10901 6.16634 7.33301 6.39001 7.33301 6.66634C7.33301 6.94267 7.10901 7.16634 6.83301 7.16634H5.01855C5.00722 7.27567 4.99967 7.38667 4.99967 7.49967C4.99967 7.61267 5.00722 7.72367 5.01855 7.83301H6.83301C7.10901 7.83301 7.33301 8.05667 7.33301 8.33301C7.33301 8.60934 7.10901 8.83301 6.83301 8.83301H5.29395C5.67061 9.62867 6.37052 10.1663 7.17285 10.1663C8.08585 10.1663 8.40745 9.84861 8.81478 9.44694C9.01078 9.25294 9.32814 9.25516 9.52181 9.4515C9.71581 9.64816 9.71392 9.96486 9.51725 10.1585C9.06259 10.6079 8.4965 11.1663 7.1735 11.1663C5.83084 11.1663 4.68304 10.1967 4.22038 8.83301H3.49967C3.22367 8.83301 2.99967 8.60934 2.99967 8.33301C2.99967 8.05667 3.22367 7.83301 3.49967 7.83301H4.01465C4.00598 7.72301 3.99967 7.61234 3.99967 7.49967C3.99967 7.38701 4.00598 7.27634 4.01465 7.16634H3.49967C3.22367 7.16634 2.99967 6.94267 2.99967 6.66634C2.99967 6.39001 3.22367 6.16634 3.49967 6.16634H4.21973C4.68273 4.80267 5.83052 3.83301 7.17285 3.83301Z"
                            fill="#63B15B"
                        />
                      </svg>
                    </span>
                    {{ formatPrice(offer.compensation) }} Euro
                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>

        <!-- Further Offers block -->

        <div v-if="furtherOffers.length > 0 && offers.length == 0" class="search_form_block">
          <h4 class="block relative font-bold text-md text-lgg mb-4" style="margin-top: 140px">
            {{ $t("pages.furtherOffers.heading") }}:
          </h4>
        </div>

        <div v-if="furtherOffers.length > 0 && offers.length > 0" class="search_form_block">
          <h4 class="block relative font-bold text-md text-lgg mb-4" style="margin-top: 140px">
            {{ $t("pages.furtherOffers.heading") }}:
          </h4>
        </div>

        <div v-if="furtherOffers.length > 0" class="newfilter-blcok mt-7">

          <div class="newfillist-block">
            <div
                v-for="(offer, key) in furtherOffers"
                :key="`${offer.offer_id} + ${key}`"
                class="
                block
                relative
                walter-block
                bg-white
                rounded-lg
                walter-shadow
                mb-4
              "
            >
              <div class="flex align-start justify-start top-block mb-0.5 p-4">
                <div class="left-block w-3/5 relative">
                  <div class="flex items-center">
                    <div class="flex items-center">
                      <h4
                          class="
                          flex
                          align-center
                          justify-start
                          relative
                          text-sm
                          font-bold
                          text-darkblack
                          flex
                          lock-text
                        "
                      ></h4>
                      {{ offer.matching_attributes }}/13 |
                      {{ $t("pages.common.buttons.dis73") }}:
                      <span
                          v-if="loggedIn"
                          @click="
                          () => {
                            if (loggedIn) {
                              $router.push({
                                name: 'offerDetails',
                                params: { id: offer.offer_id },
                              });
                            } else {
                              $router.push({ name: 'confirmCell' });
                            }
                          }
                        "
                          class="ml-1"
                      >
                        {{ offer.customer.id }}
                      </span>
                      <span v-if="!loggedIn" class="text-danger ml-1">
                        locked
                      </span>
                      <svg
                          v-if="!loggedIn"
                          width="10"
                          height="11"
                          class="ml-1.5"
                          viewBox="0 0 10 11"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                            d="M8.5 5.5H1.5C0.947715 5.5 0.5 5.94772 0.5 6.5V10C0.5 10.5523 0.947715 11 1.5 11H8.5C9.05229 11 9.5 10.5523 9.5 10V6.5C9.5 5.94772 9.05229 5.5 8.5 5.5Z"
                            fill="#EE5B64"
                        />
                        <path
                            d="M2.5 5.5V3.5C2.5 2.83696 2.76339 2.20107 3.23223 1.73223C3.70107 1.26339 4.33696 1 5 1C5.66304 1 6.29893 1.26339 6.76777 1.73223C7.23661 2.20107 7.5 2.83696 7.5 3.5V5.5"
                            stroke="#EE5B64"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                      </svg>
                    </div>

                    <div class="wrapper">
                      <svg
                          width="14"
                          height="14"
                          class="ml-1.5 show"
                          viewBox="0 0 14 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          v-if="offer.is_verified == true ? true : false"
                          @click="showVerifiedModal"
                      >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M5.26853 1.66248C5.38845 1.64971 5.51634 1.68009 5.63246 1.76143L6.2158 2.17029C6.73895 2.5362 7.44038 2.53665 7.96319 2.17029L8.54588 1.76143C8.85553 1.54451 9.25155 1.68848 9.34926 2.05375L9.53285 2.7419C9.69778 3.3585 10.2348 3.80883 10.8707 3.8643L11.5797 3.92615C11.9563 3.95901 12.1673 4.32404 12.0075 4.66638L11.706 5.31156C11.4361 5.88997 11.5577 6.58039 12.0094 7.03162L12.5127 7.53487C12.7799 7.80194 12.7069 8.21698 12.3642 8.37667L11.7191 8.67745C11.1403 8.94679 10.7903 9.5535 10.846 10.1892L10.9085 10.8988C10.9415 11.2754 10.6184 11.5463 10.2536 11.4483L9.56606 11.2634C8.94953 11.098 8.29071 11.3375 7.92478 11.8604L7.51658 12.4437C7.29985 12.7535 6.87849 12.7542 6.66176 12.4444L6.25356 11.8604C5.88763 11.3375 5.22945 11.098 4.61293 11.2634L3.92478 11.4483C3.55996 11.5463 3.23744 11.2754 3.27048 10.8988L3.33298 10.1898C3.38895 9.55391 3.03826 8.94623 2.45929 8.6768L1.8141 8.37667C1.47134 8.21692 1.39814 7.8024 1.66567 7.53487L2.16957 7.03162C2.62129 6.58039 2.74285 5.88997 2.47296 5.31156L2.17153 4.66638C2.01172 4.32404 2.22202 3.95901 2.59861 3.92615L3.30824 3.8643C3.94416 3.80883 4.48056 3.3585 4.64548 2.7419L4.82973 2.05375C4.87859 1.87112 5.00214 1.74371 5.15199 1.68917C5.18946 1.67553 5.22856 1.66673 5.26853 1.66248ZM9.14614 5.1462C9.23675 5.05311 9.36003 4.99894 9.48989 4.99516C9.59053 4.99226 9.68971 5.01981 9.77444 5.07421C9.85917 5.12861 9.92551 5.20732 9.96476 5.30005C10.004 5.39277 10.0144 5.49518 9.99446 5.59389C9.97455 5.69259 9.9253 5.78298 9.85317 5.85323L6.51983 9.18656C6.42606 9.2803 6.2989 9.33295 6.16632 9.33295C6.03373 9.33295 5.90657 9.2803 5.8128 9.18656L4.14614 7.5199C4.09815 7.47382 4.05984 7.41864 4.03345 7.35758C4.00706 7.29651 3.99311 7.2308 3.99244 7.16428C3.99176 7.09776 4.00436 7.03177 4.02951 6.97018C4.05465 6.9086 4.09183 6.85264 4.13887 6.8056C4.18591 6.75856 4.24186 6.72139 4.30345 6.69624C4.36504 6.6711 4.43103 6.65849 4.49755 6.65917C4.56407 6.65984 4.62978 6.67379 4.69085 6.70018C4.75191 6.72657 4.80709 6.76488 4.85317 6.81287L6.16632 8.12602L9.14614 5.1462Z"
                            fill="#4890D2"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M7.97231 0.942424C8.23866 0.755836 8.54077 0.670709 8.83884 0.672892C9.49461 0.677696 10.1299 1.10408 10.3148 1.79529L10.499 2.48344C10.5561 2.69684 10.7373 2.84901 10.9573 2.8682L11.667 2.93005C12.7037 3.02052 13.3533 4.14656 12.9131 5.08956L12.6123 5.73474C12.5188 5.935 12.5595 6.16783 12.7158 6.32393L13.2197 6.82719C13.9558 7.56279 13.7301 8.84327 12.7868 9.28292L12.1416 9.5837C11.9412 9.67694 11.8227 9.88184 11.8421 10.1019L11.9046 10.8116C11.9956 11.8483 10.9996 12.6838 9.99444 12.4138L9.30694 12.2295C9.09347 12.1723 8.87119 12.2528 8.74444 12.434L8.33624 13.0173C7.73964 13.8701 6.43935 13.8701 5.84275 13.0173L5.43455 12.434C5.3078 12.2528 5.08552 12.1723 4.87205 12.2295L4.18455 12.4138C3.17937 12.6838 2.18343 11.8483 2.27439 10.8116L2.33689 10.1019C2.35626 9.88184 2.23777 9.67694 2.03741 9.5837L1.39158 9.28292C0.448344 8.84333 0.222832 7.56299 0.958635 6.82719L1.46254 6.32393C1.61882 6.16783 1.66015 5.935 1.56671 5.73474L1.26528 5.08891C0.825081 4.14591 1.47527 3.02052 2.51202 2.93005L3.221 2.8682C3.44109 2.84901 3.62226 2.69684 3.67934 2.48344L3.86358 1.79529C4.0653 1.04124 4.80277 0.602953 5.51853 0.682658C5.75712 0.709227 5.9936 0.793154 6.20668 0.942424L6.78936 1.35128C6.97154 1.4787 7.20779 1.47824 7.38897 1.35128L7.97231 0.942424ZM5.63246 1.76143C5.51634 1.68009 5.38845 1.64971 5.26853 1.66248C5.22856 1.66673 5.18946 1.67553 5.15199 1.68917C5.00214 1.74371 4.87859 1.87112 4.82973 2.05375L4.64548 2.7419C4.48056 3.3585 3.94416 3.80883 3.30824 3.8643L2.59861 3.92615C2.22202 3.95901 2.01172 4.32404 2.17153 4.66638L2.47296 5.31156C2.74285 5.88997 2.62129 6.58039 2.16957 7.03162L1.66567 7.53487C1.39814 7.8024 1.47134 8.21692 1.8141 8.37667L2.45929 8.6768C3.03826 8.94623 3.38895 9.55391 3.33298 10.1898L3.27048 10.8988C3.23744 11.2754 3.55996 11.5463 3.92478 11.4483L4.61293 11.2634C5.22945 11.098 5.88763 11.3375 6.25356 11.8604L6.66176 12.4444C6.87849 12.7542 7.29985 12.7535 7.51658 12.4437L7.92478 11.8604C8.29071 11.3375 8.94953 11.098 9.56606 11.2634L10.2536 11.4483C10.6184 11.5463 10.9415 11.2754 10.9085 10.8988L10.846 10.1892C10.7903 9.5535 11.1403 8.94679 11.7191 8.67745L12.3642 8.37667C12.7069 8.21698 12.7799 7.80194 12.5127 7.53487L12.0094 7.03162C11.5577 6.58039 11.4361 5.88997 11.706 5.31156L12.0075 4.66638C12.1673 4.32404 11.9563 3.95901 11.5797 3.92615L10.8707 3.8643C10.2348 3.80883 9.69778 3.3585 9.53285 2.7419L9.34926 2.05375C9.25155 1.68848 8.85553 1.54451 8.54588 1.76143L7.96319 2.17029C7.44038 2.53665 6.73895 2.5362 6.2158 2.17029L5.63246 1.76143Z"
                            fill="#4890D2"
                        />
                      </svg>

                      <span v-if="showModal && offer.is_verified" class="tooltip">{{
                          $t("pages.common.buttons.dis125")
                        }}</span>
                    </div>
                  </div>

                  <p
                      class="
                      flex
                      items-center
                      justify-start
                      mt-0.5
                      mb-0
                      text-xs
                      font-medium
                      text-darkgray1
                    "
                      @click="
                      () => {
                        if (loggedIn) {
                          $router.push({
                            name: 'offerDetails',
                            params: { id: offer.offer_id },
                          });
                        } else {
                          $router.push({ name: 'confirmCell' });
                        }
                      }
                    "
                  >
                    <span class="mr-1.5">
                      <svg
                          class="w-3.5 h-3.5"
                          viewBox="0 0 10 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                            d="M4.99984 0.666992C2.2667 0.666992 0.0415039 2.89219 0.0415039 5.62533C0.0415039 6.85231 0.491635 7.97757 1.23096 8.84277L1.23324 8.84505L1.23494 8.84733C1.23494 8.84733 3.34426 11.2542 4.09522 11.9708C4.59809 12.4502 5.40102 12.4502 5.90389 11.9708C6.75987 11.1544 8.7653 8.84619 8.7653 8.84619L8.76644 8.84448L8.76815 8.84277C9.50813 7.97756 9.95817 6.85231 9.95817 5.62533C9.95817 2.89219 7.73297 0.666992 4.99984 0.666992ZM4.99984 1.54199C7.26004 1.54199 9.08317 3.36513 9.08317 5.62533C9.08317 6.63893 8.71379 7.55983 8.10278 8.27425C8.09881 8.2788 6.04693 10.6255 5.30005 11.3379C5.12684 11.503 4.87227 11.503 4.69906 11.3379C4.07484 10.7423 1.90266 8.28143 1.89632 8.27425L1.89575 8.27368C1.28556 7.55932 0.916504 6.63865 0.916504 5.62533C0.916504 3.36513 2.73964 1.54199 4.99984 1.54199ZM4.99984 3.87533C4.45296 3.87533 3.98741 4.09616 3.68848 4.43245C3.38955 4.76875 3.24984 5.19998 3.24984 5.62533C3.24984 6.05067 3.38955 6.4819 3.68848 6.8182C3.98741 7.15449 4.45296 7.37533 4.99984 7.37533C5.54671 7.37533 6.01227 7.15449 6.3112 6.8182C6.61013 6.4819 6.74984 6.05067 6.74984 5.62533C6.74984 5.19998 6.61013 4.76875 6.3112 4.43245C6.01227 4.09616 5.54671 3.87533 4.99984 3.87533ZM4.99984 4.75033C5.32796 4.75033 5.51866 4.85762 5.65723 5.01351C5.7958 5.1694 5.87484 5.39442 5.87484 5.62533C5.87484 5.85623 5.7958 6.08125 5.65723 6.23714C5.51866 6.39303 5.32796 6.50033 4.99984 6.50033C4.67171 6.50033 4.48102 6.39303 4.34245 6.23714C4.20388 6.08125 4.12484 5.85623 4.12484 5.62533C4.12484 5.39442 4.20388 5.1694 4.34245 5.01351C4.48102 4.85762 4.67171 4.75033 4.99984 4.75033Z"
                            fill="#676666"
                        />
                      </svg>
                    </span>
                    {{ offer.location }}
                  </p>
                </div>

                <div class="right-block w-2/4 relative">
                  <p
                      class="
                      wishlist-icon
                      relative
                      text-sm text-right
                      flex
                      items-center
                      justify-end
                      mt-0
                      font-bold
                    "
                  >
                    <button
                        v-if="offer.favorite"
                        @click.prevent="selectedOffers(offer.offer_id, offer)"
                        :offer="offer"
                    >
                      <svg
                          width="20"
                          height="18"
                          viewBox="0 0 20 18"
                          fill="none"
                          :active="true"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                            d="M5.5 0.5C2.47122 0.5 0 2.97122 0 6C0 8.04808 1.54382 9.97645 3.42578 11.9541C5.30774 13.9318 7.62419 15.9347 9.46973 17.7803C9.61038 17.9209 9.80112 17.9999 10 17.9999C10.1989 17.9999 10.3896 17.9209 10.5303 17.7803C12.3758 15.9347 14.6923 13.9318 16.5742 11.9541C18.4562 9.97645 20 8.04808 20 6C20 2.97122 17.5288 0.5 14.5 0.5C12.7618 0.5 11.2484 1.43324 10 3.01855C8.75159 1.43324 7.23822 0.5 5.5 0.5ZM5.5 2C6.96429 2 8.18315 2.7792 9.36621 4.65039C9.43386 4.75727 9.52744 4.84531 9.63826 4.90632C9.74907 4.96732 9.87351 4.99931 10 4.99931C10.1265 4.99931 10.2509 4.96732 10.3617 4.90632C10.4726 4.84531 10.5661 4.75727 10.6338 4.65039C11.8168 2.7792 13.0357 2 14.5 2C16.7182 2 18.5 3.78178 18.5 6C18.5 7.20192 17.2938 9.02355 15.4883 10.9209C13.8418 12.6511 11.7952 14.4587 10 16.209C8.20484 14.4587 6.15821 12.6511 4.51172 10.9209C2.70618 9.02355 1.5 7.20192 1.5 6C1.5 3.78178 3.28178 2 5.5 2Z"
                            fill="#63B15B"
                        />
                        <path
                            d="M5.5 2C6.96429 2 8.18315 2.7792 9.36621 4.65039C9.43386 4.75727 9.52744 4.84531 9.63826 4.90632C9.74907 4.96732 9.87351 4.99931 10 4.99931C10.1265 4.99931 10.2509 4.96732 10.3617 4.90632C10.4726 4.84531 10.5661 4.75727 10.6338 4.65039C11.8168 2.7792 13.0357 2 14.5 2C16.7182 2 18.5 3.78178 18.5 6C18.5 7.20192 17.2938 9.02355 15.4883 10.9209C13.8418 12.6511 11.7952 14.4587 10 16.209C8.20484 14.4587 6.15821 12.6511 4.51172 10.9209C2.70618 9.02355 1.5 7.20192 1.5 6C1.5 3.78178 3.28178 2 5.5 2Z"
                            fill="#63B15B"
                        />
                      </svg>
                    </button>

                    <button
                        v-else
                        @click.prevent="selectedOffers(offer.offer_id, offer)"
                        :class="offer.favorite === true ? true : false"
                        :offer="offer"
                    >
                      <svg
                          width="20"
                          height="18"
                          viewBox="0 0 20 18"
                          class=""
                          :active="false"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                            d="M5.5 0.5C2.47122 0.5 0 2.97122 0 6C0 8.04808 1.54382 9.97645 3.42578 11.9541C5.30774 13.9318 7.62419 15.9347 9.46973 17.7803C9.61038 17.9209 9.80112 17.9999 10 17.9999C10.1989 17.9999 10.3896 17.9209 10.5303 17.7803C12.3758 15.9347 14.6923 13.9318 16.5742 11.9541C18.4562 9.97645 20 8.04808 20 6C20 2.97122 17.5288 0.5 14.5 0.5C12.7618 0.5 11.2484 1.43324 10 3.01855C8.75159 1.43324 7.23822 0.5 5.5 0.5ZM5.5 2C6.96429 2 8.18315 2.7792 9.36621 4.65039C9.43386 4.75727 9.52744 4.84531 9.63826 4.90632C9.74907 4.96732 9.87351 4.99931 10 4.99931C10.1265 4.99931 10.2509 4.96732 10.3617 4.90632C10.4726 4.84531 10.5661 4.75727 10.6338 4.65039C11.8168 2.7792 13.0357 2 14.5 2C16.7182 2 18.5 3.78178 18.5 6C18.5 7.20192 17.2938 9.02355 15.4883 10.9209C13.8418 12.6511 11.7952 14.4587 10 16.209C8.20484 14.4587 6.15821 12.6511 4.51172 10.9209C2.70618 9.02355 1.5 7.20192 1.5 6C1.5 3.78178 3.28178 2 5.5 2Z"
                            fill="#63B15B"
                        />
                      </svg>
                    </button>
                  </p>
                </div>
              </div>
              <div
                  class="
                  flex
                  align-start
                  justify-start
                  top-block
                  mb-0.5
                  pl-4
                  pb-4
                  pr-4
                "
                  @click="
                  () => {
                    if (loggedIn) {
                      $router.push({
                        name: 'offerDetails',
                        params: { id: offer.offer_id },
                      });
                    } else {
                      $router.push({ name: 'confirmCell' });
                    }
                  }
                "
              >
                <div class="left-block w-3/5 relative">
                  <h4
                      class="block relative text-sm font-bold text-darkblack flex"
                  >
                    {{
                      formatDate(offer.arrival_date, "DD.MM.YYYY", "YYYY-MM-DD")
                    }}
                  </h4>
                </div>
                <div class="right-block w-2/4 relative">
                  <p
                      class="
                      flex
                      items-center
                      justify-end
                      text-right
                      mt-0.5
                      mb-0
                      text-smm
                      font-bold
                      text-darkgray1
                    "
                  >
                    <span class="mr-0.5">
                      <svg
                          width="14"
                          height="13"
                          viewBox="0 0 14 15"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                            d="M6.99967 0.833008C3.3237 0.833008 0.333008 3.8237 0.333008 7.49967C0.333008 11.1757 3.3237 14.1663 6.99967 14.1663C10.6757 14.1663 13.6663 11.1757 13.6663 7.49967C13.6663 3.8237 10.6757 0.833008 6.99967 0.833008ZM7.17285 3.83301C8.49619 3.83301 9.06259 4.39182 9.51725 4.84082C9.71392 5.03482 9.71581 5.35118 9.52181 5.54785C9.32814 5.74452 9.01078 5.74641 8.81478 5.55241C8.40778 5.15074 8.0865 4.83301 7.1735 4.83301C6.37117 4.83301 5.67028 5.37067 5.29395 6.16634H6.83301C7.10901 6.16634 7.33301 6.39001 7.33301 6.66634C7.33301 6.94267 7.10901 7.16634 6.83301 7.16634H5.01855C5.00722 7.27567 4.99967 7.38667 4.99967 7.49967C4.99967 7.61267 5.00722 7.72367 5.01855 7.83301H6.83301C7.10901 7.83301 7.33301 8.05667 7.33301 8.33301C7.33301 8.60934 7.10901 8.83301 6.83301 8.83301H5.29395C5.67061 9.62867 6.37052 10.1663 7.17285 10.1663C8.08585 10.1663 8.40745 9.84861 8.81478 9.44694C9.01078 9.25294 9.32814 9.25516 9.52181 9.4515C9.71581 9.64816 9.71392 9.96486 9.51725 10.1585C9.06259 10.6079 8.4965 11.1663 7.1735 11.1663C5.83084 11.1663 4.68304 10.1967 4.22038 8.83301H3.49967C3.22367 8.83301 2.99967 8.60934 2.99967 8.33301C2.99967 8.05667 3.22367 7.83301 3.49967 7.83301H4.01465C4.00598 7.72301 3.99967 7.61234 3.99967 7.49967C3.99967 7.38701 4.00598 7.27634 4.01465 7.16634H3.49967C3.22367 7.16634 2.99967 6.94267 2.99967 6.66634C2.99967 6.39001 3.22367 6.16634 3.49967 6.16634H4.21973C4.68273 4.80267 5.83052 3.83301 7.17285 3.83301Z"
                            fill="#63B15B"
                        />
                      </svg>
                    </span>
                    {{ formatPrice(offer.compensation) }} Euro
                  </p>
                </div>
              </div>
            </div>

          </div>

        </div>
        <!-- Further Offers Block -->


      </div>
    </div>
    <div class="list-group-wrapper">
      <transition name="fade">
        <div class="loading" v-show="isLoading">
          <span class="fa fa-spinner fa-spin"></span> Loading
        </div>
      </transition>
    </div>
    <Filters :show-filters.sync="showFilters" :reset="resetFilters"/>
  </div>
</template>

<script>
import SearchCard from "@/components/cards/SearchCard";
import FilterSVG from "@/components/shared/svgs/FilterSVG";
import Filters from "@/components/modals/Filters";
import LoadingSpinner from "@/components/LoadingSpinner";
import moment from "moment";
import {isEmpty} from "lodash";
import {mapGetters} from "vuex";

export default {
  name: "Search",
  components: {LoadingSpinner, FilterSVG, SearchCard, Filters},
  props: ["offer", "furtherOffer"],
  data() {
    return {
      showFilters: false,
      scrollState: false,
      selectedDate: moment().format("DD.MM.YYYY"),
      resetFilters: false,
      text: String,
      isModalVisible: false,
      showModal: false,
      dataOffers: [],
      isInfoModal: false,
      openloading: "",
      isLoading: false,
      isActive: false,
      getPageNumber: "",
      currentPage: 0,
      onPage: 0,
    };
  },

  computed: {
    offers() {
      return this.$store.getters["offer/list"];
    },
    ...mapGetters("offer", {
      details: "total_pages_count",
      pageLoading: "pageLoading",
    }),
    furtherOffers() {
      return this.$store.getters["furtherOffer/list"];
    },
    ...mapGetters("furtherOffer", {
      details: "total_pages_count",
      pageLoading: "pageLoading",
    }),
  },
  created() {
    this.fetchOffers();
    this.fetchFurtherOffers();
  },

  mounted() {
    window.addEventListener("scroll", this.handleScroll);

  },
  destroyed() {
    window.document
        .getElementsByClassName("header_main")[0]
        .classList.remove("fixed_header");

    this.scrollState = false;
    window.removeEventListener("scroll", this.handleScroll);
  },

  methods: {
    formatPrice(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    showVerifiedModal() {
      this.showModal = true;
      setTimeout(() => {
        this.showModal = false;
      }, 1000);
    },
    fetchOffers() {
      this.$store.dispatch("offer/list").then(() => {
        setTimeout(() => {
          this.$store.commit("offer/updatePageLoading", false)
        }, 1000);
      });
    },
    fetchFurtherOffers() {
      this.$store.dispatch("furtherOffer/list").then(() => {
        setTimeout(() => {
          this.$store.commit("furtherOffer/updatePageLoading", false)
        }, 1000);
      });
    },
    isEmpty(val) {
      return isEmpty(val);
    },
    paginate(pageNumber) {
      this.isLoading = true;

      this.$store.dispatch("offer/paginate", pageNumber).then(() => {
        this.isLoading = false;
      });
    },

    InfoModal() {
      this.isInfoModal = !this.isInfoModal;
    },
    selectedOffers(id, val) {
      this.$store.dispatch("offer/toggleFav", {
        offerId: id,
        page: "list",
      });
      val.favorite = !val.favorite;

    },

    handleScroll(e) {
      if (this.offers.length > 4) {
        if (window.scrollY > 150) {
          window.document
              .getElementsByClassName("header_main")[0]
              .classList.add("fixed_header");

          this.scrollState = true;
          let bottomOfWindow =
              window.innerHeight + Math.ceil(window.pageYOffset) >=
              document.body.offsetHeight;

          if (bottomOfWindow) {
            if (this.onPage + 1 < this.details) {
              this.isLoading = true;
              this.paginate(this.onPage + 1);
              this.onPage += 1;
            }
          }
        } else {
          window.document
              .getElementsByClassName("header_main")[0]
              .classList.remove("fixed_header");

          this.scrollState = false;
        }
      }
    },
    onDate(val) {
      this.selectedDate = val;
    },
    resetFilter() {
      this.$store.commit("app/showNotification", {
        heading: this.$t("pages.common.buttons.questions1"),
        desc: this.$t("pages.common.buttons.questions2"),
        buttons: {
          okay: {
            text: this.$t("pages.common.buttons.questions1"),
            action: () => {
              this.resetFilters = true;
              this.showFilters = true;
            },
          },
          cancel: {
            text: this.$t("pages.common.buttons.questions3"),
            action: () => {
            },
          },
        },
      });
    },
  },
};
</script>

<style>
.main-nav {
  display: none;
}

.bggreen {
  background: #63b15b;
}

.page_title {
  display: none;
}

.test {
  display: block;
}

.dst-search {
  width: 100%;
}

.scrollssearch_block .search_form_block .search-card {
  width: 100% !important;
  margin-right: 2% !important;
}

.textgrays {
  color: #676666;
}

.textblack {
  color: #000;
}

.scrollssearch_block {
  top: 50px;
  z-index: 99;
}

.header_main {
  top: 0;
  left: 0;
  z-index: 9999;
}

.fixed_header {
  position: fixed !important;
}

.offer_main_block .offerno_result {
  display: block;
  position: relative;
  padding: 20px 20px 20px;
}

.offer_main_block .offerno_result .iconbox {
  text-align: center;
  margin: 0 0 15px;
}

.offer_main_block .offerno_result h5 {
  text-align: center;
  font-size: 17px;
  font-weight: bold;
  text-transform: capitalize;
  margin: 0 0 0;
}

.offer_main_block .offerno_result p {
  font-size: 17px;
  text-align: center;
  margin: 0 0 10px;
}

.offer_main_block .offerno_result p .reset_fill {
  color: #63b15b;
}

.offer_main_block .offerno_result {
  padding: 10px 0;
  margin: 15px 0 0;
}

.offer_main_block .offerno_result .iconbox {
  margin: 0 0 10px;
}

.offer_main_block .offerno_result h5 {
  font-size: 14px;
}

.offer_main_block .offerno_result p {
  font-size: 14px;
  margin: 0 0 6px;
}

.offer_main_block .offerno_result p .reset_fill {
  color: #63b15b;
}

.vdp-datepicker__calendar {
  top: 100%;
}

.bessere-min-height {
  min-height: 136px;
}

.ds-cunstome-picker .vdp-datepicker__calendar {
  box-shadow: 0px 20px 76px rgb(0 0 0 / 25%);
  border-radius: 0px 0px 8px 8px;
}

.modal-vue .overlay {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-vue .modal {
  position: relative;
  width: 300px;
  z-index: 9999;
  margin: 0 auto;
  padding: 20px 30px;
  background-color: #fff;
}

.modal-vue .close {
  position: absolute;
  top: 10px;
  right: 10px;
}

.tooltip {
  position: absolute;
  top: -18px;
  margin-left: 28px;
  max-width: 236px;
  opacity: 0;

  padding: 10px;
  height: 37px;

  color: white;
  text-align: center;
  background: #63b15b;
  border-radius: 5px;
  white-space: nowrap;
}

.wrapper:hover > .tooltip {
  opacity: 1;
}

.list-group-wrapper {
  position: relative;
}

.list-group {
  overflow: auto;
  height: 50vh;
  border: 2px solid #dce4ec;
  border-radius: 5px;
}

.list-group-item {
  margin-top: 1px;
  border-left: none;
  border-right: none;
  border-top: none;
  border-bottom: 2px solid #dce4ec;
}

#openloading {
  display: inline-block;
  width: 50px;
  height: 50px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: #63b15b;
  margin-left: 148px;
  animation: spin 1s ease-in-out infinite;
  -webkit-animation: spin 1s ease-in-out infinite;
}

.loading {
  vertical-align: middle;
  text-align: center;
}

@keyframes spin {
  to {
    -webkit-transform: rotate(360deg);
  }
}

@-webkit-keyframes spin {
  to {
    -webkit-transform: rotate(360deg);
  }
}
</style>
